import _ from 'lodash';
import { assign, enums, mask, object, omit, optional, partial, string } from 'superstruct';
import { BaseFilterDto, BaseFilterFormExtraFieldsDto, DefaultBaseFilterFormValues, DELETE_FILTER_TYPES } from '@arc/shared/util-filters';
import { parsableArray, requireFields } from '@arc/shared/util-superstruct';
import { CLEANUP_STATUSES } from './view-cleanup-task.dto';
const CleanupTaskBaseFilterDto = assign(omit(BaseFilterDto, ['viewMode', 'createdType', 'createdRangeStart', 'createdRangeEnd']), object({
  status: optional(parsableArray(enums(CLEANUP_STATUSES))),
  deleteAtType: requireFields(enums(DELETE_FILTER_TYPES), ['deleteAtRangeStart', 'deleteAtRangeEnd'], {
    amountRequired: 1,
    validator: value => value === 'custom',
    message: 'validations:Required Custom Date'
  }),
  deleteAtRangeStart: string(),
  deleteAtRangeEnd: string()
}));
export const CleanupTaskFilterQueryDto = partial(CleanupTaskBaseFilterDto);
export const CleanupTaskFilterFormDto = assign(CleanupTaskBaseFilterDto, BaseFilterFormExtraFieldsDto);
export const parameterizeCleanupTaskFilterFormDto = filter => _.omit(_.pick(_.pickBy(filter, _.identity), Object.keys(CleanupTaskFilterQueryDto.schema)), ['saved']);
export const DefaultCleanupTaskFilterFormDto = () => mask({
  ...DefaultBaseFilterFormValues(),
  originalName: null,
  status: [],
  deleteAtType: 'all-time',
  deleteAtRangeStart: '',
  deleteAtRangeEnd: '',
  generatedName: 'Cleanup Task Filter',
  nameEdited: false
}, CleanupTaskFilterFormDto);
export const DefaultCleanupTaskFilterQueryDto = () => parameterizeCleanupTaskFilterFormDto(DefaultCleanupTaskFilterFormDto());
export const cleanupTaskFilterDefinition = {
  type: 'cleanup-tasks',
  queryDto: CleanupTaskFilterQueryDto,
  formDto: CleanupTaskFilterFormDto,
  parameterize: parameterizeCleanupTaskFilterFormDto
};